import { Button, Tooltip } from '@hover/blueprint';
import { iMaximize, iX } from '@hover/icons';
import React from 'react';

import {
  isDesignStudioInIframe,
  isIframeFullscreen,
  toggleFullscreen,
} from 'src/modules/designStudio/helpers/fullscreenIframe';
import { useToolbarDisplaySettings } from 'src/modules/designStudio/hooks';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const FullscreenIframeButton = ({ loading }: { loading: boolean }) => {
  const { shouldDisplayFullscreenButton, onlyDisplayToolbarInFullscreen } =
    useToolbarDisplaySettings();
  const isFullscreen = isIframeFullscreen();
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);

  if (!shouldDisplayFullscreenButton) {
    return null;
  }

  return (
    <Tooltip
      hasArrow={false}
      isDisabled={isFullscreen}
      label={
        onlyDisplayToolbarInFullscreen
          ? t('fullscreen.tooltipText.noToolbar')
          : t('fullscreen.tooltipText.withToolbar')
      }
    >
      <Button
        iconAfter={isFullscreen ? iX : iMaximize}
        label="fullscreen"
        onClick={toggleFullscreen}
        position="absolute"
        shape="box"
        style={{
          top: loading ? '-50px' : '8px',
          right: '8px',
          transition: 'all 300ms ease-out 500ms',
        }}
        zIndex={1000}
      >
        {isFullscreen ? t('fullscreen.exitText') : t('fullscreen.enterText')}
      </Button>
    </Tooltip>
  );
};

export {
  FullscreenIframeButton,
  isDesignStudioInIframe,
  isIframeFullscreen,
  toggleFullscreen,
};
